import { ComposeUniqueState } from '../../store/schema/FilePickerUploadConfiguration';
import { assertNever } from 'owa-assert';

export default function doesComposeSupportReferenceAttachment(
    composeUniqueState: ComposeUniqueState
): boolean {
    switch (composeUniqueState) {
        case ComposeUniqueState.PlainText:
        case ComposeUniqueState.Encrypted:
            return false;
        case ComposeUniqueState.None:
        case ComposeUniqueState.GroupCalendar:
            return true;
        default:
            return assertNever(composeUniqueState);
    }
}
